import { useContext, useEffect, useState } from "react";
import client from "../../../contentfulClient";
import "./OurServices.scss";
import { MainContext } from "../../../MainContext";
import useScrollAnimation from "../../useAnimationScrolling";

export const OurServices = () => {
        const { polygraphTypes, polygraphTypesRef, openModal, staticTexts: { learnMoreButton: learnMoreButton }, staticTexts: { servicesTitle: servicesTitle }, } = useContext(MainContext);

    const animationConfig = {
        scale: [0, 1],
        opacity: [0, 1],
        duration: 1000,
        easing: "easeOutExpo",
    };

    useScrollAnimation(polygraphTypesRef, animationConfig, polygraphTypes);

    return (
        <div className="our-service-container">
            <section className="our-services">
                <div className="grid">
                    {polygraphTypes.map((service: any, index: number) => (
                        <div
                            className="service-card"
                            ref={(el) => {
                                if (el) polygraphTypesRef.current[index] = el;
                            }}
                            key={index}
                        >
                            <img src={service.image} alt="" className="image" />
                            <h3 className="title">{service.title}</h3>
                            <p className="service-description">{service.subTitle}</p>
                            <div className="btn-gray" onClick={() => openModal({ ...service })}>
                                {learnMoreButton.text}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};
